import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuid } from "uuid";
import {
  getSupplier,
  getNext,
  getPrevious,
  getParticularPage,
  getSupplierById,
  createSupplier,
  updateSupplier,
  handleSearch,
} from "./thunk";

const initialState = {
  suppliers: [],
  edit: false,
  supplier: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingSupplier: false,
  loadingNext: false,
  contacts: [],
  docAttachments: [],
  showCreateModal: false,
};

export const supplierSlice = createSlice({
  name: "supplier",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    contactsUpdate: (state, action) => {
      state.contacts = action.payload;
    },

    docAttachmentsUpdate: (state, action) => {
      state.docAttachments = action.payload;
    },
    clearAllSupplier: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingSupplier = false;
      state.supplier = null;
      state.contacts = [];

      state.docAttachments = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSupplierById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSupplierById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.supplier = action.payload.data;
      state.contacts = action.payload.data.contacts.map((item) => {
        return { ...item, unique: uuid() };
      });
      state.docAttachments = action.payload.data.docAttachments.map((item) => {
        return { ...item, unique: uuid() };
      });
    });
    builder.addCase(getSupplierById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createSupplier.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createSupplier.fulfilled, (state, action) => {
      state.loadingCreate = false;
      state.edit = false;
    });
    builder.addCase(createSupplier.rejected, (state) => {
      state.loadingCreate = false;
      state.edit = false;
    });
    builder.addCase(updateSupplier.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateSupplier.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateSupplier.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getSupplier.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingSupplier = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getSupplier.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingSupplier = false;
        state.suppliers = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getSupplier.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingSupplier = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, supplierEdit, contactsUpdate, docAttachmentsUpdate, clearAllSupplier } =
  supplierSlice.actions;

export default supplierSlice.reducer;
